<template>
  <v-container id="selectorpersona-caplp">
    <v-row>
      <v-col cols="2" md="2" lg="2">
        <v-text-field
          v-model="dni"
          label="DNI"
          height="20px"
          v-on:keyup.enter="BuscarPersona"
        />
      </v-col>
      <v-col cols="6" md="8" lg="8">
        <v-text-field
          v-model="persona"
          :label="titulo.length>0 ? titulo : 'Apellido y Nombre'"
          height="20px"
          v-on:keyup.enter="BuscarPersona"
        />
      </v-col>
      <v-col cols="4" md="2" lg="2">
        <v-btn
          class="ma-2"
          fab
          dark
          x-small
          color="primary"
          title="Buscar"
          @click="BuscarPersona"
        >
          <v-icon
            dark
          >
            mdi-magnify
          </v-icon>
        </v-btn>
        <v-btn
          class="ma-2"
          fab
          dark
          x-small
          color="primary"
          title="Quitar Filtro"
          @click="QuitarFiltroPersona"
        >
          <v-icon
            dark
          >
            mdi-cancel
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="dialogmensaje = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-dialog v-model="dialogselpersona" persistent max-width="950">
      <v-card>
        <v-card-title class="headline">
          Seleccione Persona
        </v-card-title>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="dialogselpersona = false">
            Cerrar
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-data-table
            :headers="columnaspersona"
            :items="listapersonas"
            :items-per-page="10"
            :footer-props="{'items-per-page-text': 'Filas por Página:',
                            'items-per-page-all-text' : 'Todos'}"
            class="elevation-1"
            dense
            no-data-text="Sin Registros"
            multi-sort
            >
            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="seleccionarPersona(item)"
              >
                mdi-arrow-right
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import axios from '@/axios'
  export default {
    props: ['idalumno','titulo'],
    data() {
      return {
        loading: false,
        dialogmensaje: false,
        mensajetitulo: '',
        mensajecuerpo: '',
        dni: '',
        persona: '',
        listapersonas: [],
        dialogselpersona: false,
        columnaspersona: [
          {
            text: 'Op.',
            align: 'center',
            value: 'actions',
            sortable: false,
            width: 100
          },
          {
            text: 'ID',
            align: 'center',
            sortable: true,
            value: 'idpersona',
            width: 15
          },
          {
            text: 'Apellido',
            align: 'center',
            sortable: true,
            value: 'apellido',
            width: 220
          },
          {
            text: 'Nombre',
            align: 'center',
            sortable: true,
            value: 'nombre',
            width: 220
          },
          {
            text: 'Documento',
            align: 'center',
            sortable: true,
            value: 'nrodoc',
            width: 150
          },
          {
            text: 'Fecha Nacim',
            align: 'left',
            sortable: true,
            value: 'fechanacdmy',
            width: 150
          },
          {
            text: 'Localidad',
            align: 'left',
            sortable: true,
            value: 'localidad',
            width: 150
          }
        ]
      }
    },
    mounted() {
      this.dni=''
      this.persona=''
    },
    methods: {
      MostrarMensaje(titulo, cuerpo) {
        this.mensajetitulo = titulo;
        this.mensajecuerpo = cuerpo;
        this.dialogmensaje = true;
      },
      BuscarPersona (){
        this.loading = true
        if((this.persona!='' && this.persona!=null) || (this.dni!='' && this.dni!=null))
        {
            var persona= this.persona!='' ? this.persona : ' ';
            var dni= this.dni!='' ? + this.dni : ' ';
            var idalu= this.idalumno!=null && this.idalumno!=0 ? this.idalumno : '0';
            axios.get('persona/selectorpersona/'+ dni + '/' + persona + '/' + idalu)
            .then((result) => {
              if(result.data.resultado===0){
                this.listapersonas = result.data.datos;
                this.loading = false;
                if(this.listapersonas.length===0)
                {
                  if(this.idalumno===null || this.idalumno===0){
                    this.MostrarMensaje('Atención','No existen personas con los criterios seleccionados!!!',false);
                  }else{
                    this.MostrarMensaje('Atención','No existen personas vinculadas al alumno/a con los criterios seleccionados!!!',false);
                  }
                }
                else if(this.listapersonas.length===1)
                {
                /*trae persona*/
                  this.dni= this.listapersonas[0].nrodoc;
                  this.persona= this.listapersonas[0].apellido + '' + this.listapersonas[0].nombre;
                  this.$emit('selPersona', this.listapersonas[0]);
                }else{
                /*abre cuadro con lista para seleccionar*/
                  this.dialogselpersona=true;
                }
              }else{
                this.loading = false
                this.MostrarMensaje('Atención','Error al consultar!!!',false);
              }
            })
            .catch((error) => {
                this.loading = false
                this.MostrarMensaje('Error', error)
            })
        }else{
          this.loading = false
          this.MostrarMensaje('Error', 'Debe ingresar DNI o Nombre o Razón Social!!!')
        }
      },
      QuitarFiltroPersona () {
        this.dni=''
        this.persona=''
        this.listapersonas=[]
        this.$emit('selPersona', null)
      },
      seleccionarPersona (item) {
        this.loading=true;
        this.dni= item.nrodoc;
        this.persona= item.apellido + ' ' + item.nombre;
        this.$emit('selPersona', item);
        this.dialogselpersona=false;
        this.loading=false;
      }
    }
  };
</script>
<style>
</style>